import { hasClass } from '../has-class';

export function isAncestorOfClass(
	element: Element,
	className: string,
	includeSelf: boolean
): boolean {
	let parent = element.parentElement;
	if (includeSelf && element.classList.contains(className)) {
		return true;
	}
	while (parent && parent.nodeType && parent.nodeType === 1) {
		if (parent.classList.contains(className)) {
			return true;
		}
		parent = parent.parentElement;
	}
	return false;
}
